import * as firebase from "firebase"

// Get a Firestore instance
export const app = firebase.initializeApp({

// Projekt: Formation-dev
    // apiKey: "AIzaSyCcCNSmfCAm1wmxMFRUUbciXpWl-4nd1yA",
    // authDomain: "formation-dev-5dbfa.firebaseapp.com",
    // databaseURL: "https://formation-dev-5dbfa.firebaseio.com",
    // projectId: "formation-dev-5dbfa",
    // storageBucket: "formation-dev-5dbfa.appspot.com",
    // messagingSenderId: "509308426642",
    // appId: "1:509308426642:web:bc32741c66fa350707894b",
    // measurementId: "G-FXQMM68WVQ"

// Projekt: Formation-LIVE
    apiKey: "AIzaSyCHykBx_Q4ey8fFr0jceUIiolnNUFBImf8",
    authDomain: "formation-live.firebaseapp.com",
    databaseURL: "https://formation-live.firebaseio.com",
    projectId: "formation-live",
    storageBucket: "formation-live.appspot.com",
    messagingSenderId: "329602504475",
    appId: "1:329602504475:web:e95a95b3c31f1d709965be",
    measurementId: "G-FXQMM68WVQ"
})

export const db = firebase.firestore(app);

// ENDAST PÅ LIVE
export const analytics = firebase.analytics();
// ENDAST PÅ LIVE
export const performance = firebase.performance();


// Export types that exists in Firestore
// This is not always necessary, but it's used in other examples
const { TimeStamp, GeoPoint } = firebase.firestore
export { TimeStamp, GeoPoint }

// Variable for Firebase login
export const auth = firebase.auth()

// Variable for incrementing
export const increment = firebase.firestore.FieldValue.increment(1)
export const decrement = firebase.firestore.FieldValue.increment(-1)

// Variable for timestamp
export const time = firebase.firestore.FieldValue.serverTimestamp()
